var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChile = function SvgChile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 473.684 473.684",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#efecec",
    d: "M334.938 236.842H473.68C473.68 106.032 367.645 0 236.838 0c65.402 0 98.1 118.421 98.1 236.842z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#db2f2a",
    d: "M290.635 236.842c0 118.425-53.798 236.842-53.798 236.842 130.807 0 236.842-106.043 236.842-236.842H290.635z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f4f5",
    d: "M.003 236.842h334.935C334.938 118.421 302.24 0 236.838 0 106.038 0 .003 106.032.003 236.842z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e13e3e",
    d: "M334.938 236.842H.003c0 130.799 106.036 236.842 236.835 236.842 65.402 0 98.1-118.417 98.1-236.842z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3757a6",
    d: "M177.2 7.584C75.273 34.026.003 126.633.003 236.842H177.2V7.584z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.315 89.428 12.367 38.073h40.037l-32.39 23.529 12.375 38.073-32.389-23.53-32.388 23.53 12.37-38.073-32.387-23.529h40.035z"
  })));
};
export default SvgChile;